import type { UsersResources } from '../en/users';

export const users: UsersResources = {
  title: 'Benutzer',
  loading: 'Benutzer werden geladen …',
  error: 'Benutzer konnten nicht geladen werden.',
  list: {
    searchPlaceholder: 'Suche nach Name oder E-Mail…',
    empty: {
      title: 'Noch keine Benutzer',
    },
    noResults: {
      title: 'Keine Benutzer gefunden',
      description: 'Passen Sie Ihre Suche oder Filter an, um wieder Ergebnisse zu sehen.',
      reset: 'Suche und Filter zurücksetzen',
    },
    columns: {
      person: 'Person',
      groups: 'Gruppen',
      status: 'Status',
    },
    result: { singular: 'Benutzer', plural: 'Benutzer' },
  },
  state: {
    Active: 'Aktiv',
    Invited: 'Eingeladen',
    Pending: 'Ausstehend',
    Deactivated: 'Deaktiviert',
  },
  detail: {
    title: 'Benutzer',
    back: 'Alle Benutzer',
    error: 'Benutzer konnte nicht geladen werden.',
    cards: {
      identity: 'Identität',
      access: 'Zugriff',
    },
    fields: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      groups: 'Gruppen',
      state: 'Status',
    },
    groupsField: {
      empty: 'In diesem Mandanten gibt es noch keine Gruppen.',
      loading: 'Gruppen werden geladen …',
      error: 'Gruppen konnten nicht geladen werden.',
    },
    actions: {
      activate: 'Benutzer aktivieren',
      deactivate: 'Benutzer deaktivieren',
      selfExplanation: 'Sie können Ihr eigenes Konto nicht deaktivieren.',
      editGroups: 'Gruppen bearbeiten',
      save: 'Speichern',
      saving: 'Speichern …',
      cancel: 'Abbrechen',
      selfEditExplanation: 'Sie können Ihre eigene Gruppenmitgliedschaft nicht bearbeiten.',
    },
    toast: {
      activated: 'Benutzer aktiviert',
      deactivated: 'Benutzer deaktiviert',
      groupsUpdated: 'Gruppen aktualisiert',
    },
    deactivateConfirm: {
      title: '{{name}} deaktivieren?',
      description: 'Der Benutzer verliert den Zugriff auf diesen Mandanten, der Datensatz bleibt jedoch erhalten.',
      cancel: 'Abbrechen',
      confirm: 'Deaktivieren',
    },
    unsavedChanges: {
      title: 'Änderungen verwerfen?',
      description: 'Ihre Änderungen an den Gruppen dieses Benutzers wurden nicht gespeichert.',
      keepEditing: 'Weiter bearbeiten',
      discard: 'Verwerfen',
    },
  },
};
